export default "__VITE_ASSET__B8x_mwBh__"